import { useState, useEffect } from "react";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import FormField from "layouts/pages/account/components/FormField";
import userProfileService from "services/userProfileService";
import SoftSnackbar from "components/SoftSnackbar";

function BasicInfo() {
  const [formData, setFormData] = useState({
    Vorname: "",
    Nachname: "",
    email: "",
    phone: "",
    ustid: "",
    company: "",
    billingemail: "",
  });

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    color: "info",
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        setLoading(true);
        const profileData = await userProfileService.getProfile();
        setFormData({
          Vorname: profileData.Vorname || "",
          Nachname: profileData.Nachname || "",
          email: profileData.email || "",
          phone: profileData.phone || "",
          ustid: profileData.ustid || "",
          company: profileData.company || "",
          billingemail: profileData.billingemail || "",
        });
      } catch (error) {
        console.error("Error loading profile data:", error);
        setSnackbar({
          open: true,
          message: "Fehler beim Laden der Profildaten",
          color: "error",
        });
      } finally {
        setLoading(false);
      }
    };

    fetchProfileData();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await userProfileService.updateProfile(formData);
      setSnackbar({
        open: true,
        message: "Profildaten erfolgreich gespeichert",
        color: "success",
      });
    } catch (error) {
      console.error("Error saving profile data:", error);
      setSnackbar({
        open: true,
        message: "Fehler beim Speichern der Profildaten",
        color: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <>
      <Card id="account-daten" sx={{ overflow: "visible" }}>
        <SoftBox p={3}>
          <SoftTypography variant="h5">Accountdaten</SoftTypography>
        </SoftBox>
        <SoftBox component="form" pb={3} px={3} onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <FormField 
                label="Vorname" 
                placeholder="Vorname eingeben" 
                name="Vorname"
                value={formData.Vorname}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormField 
                label="Nachname" 
                placeholder="Nachname eingeben" 
                name="Nachname"
                value={formData.Nachname}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormField
                label="E-Mail"
                placeholder="E-Mail eingeben"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                inputProps={{ type: "email" }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormField
                label="Telefonnummer"
                placeholder="Telefonnummer eingeben"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormField 
                label="USt-Id" 
                name="ustid"
                value={formData.ustid}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormField 
                label="Firmenname" 
                placeholder="Firmenname eingeben" 
                name="company"
                value={formData.company}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormField
                label="Buchhaltungs-E-Mail"
                placeholder="Buchhaltungs-E-Mail eingeben"
                name="billingemail"
                value={formData.billingemail}
                onChange={handleInputChange}
                inputProps={{ type: "email" }}
              />
            </Grid>
          </Grid>
          <SoftBox mt={3} display="flex" justifyContent="flex-end">
            <SoftButton 
              variant="gradient" 
              color="info" 
              type="submit"
              disabled={loading}
            >
              {loading ? "Wird gespeichert..." : "Speichern"}
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </Card>
      <SoftSnackbar
        color={snackbar.color}
        icon="notifications"
        title="Hinweis"
        content={snackbar.message}
        open={snackbar.open}
        onClose={handleCloseSnackbar}
        close={handleCloseSnackbar}
        bgWhite
      />
    </>
  );
}

export default BasicInfo;
